(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/participant-info.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/participant-info.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  forwardRef
} = React;
const {
  default: TippyReact
} = Tippy;
const {
  Link
} = ReactRouterDOM;
const {
  RevealLink
} = svs.components.lbUi;
const {
  ImageTypes,
  getImageOptions
} = svs.racing.common.imageOptions;
const {
  useNavigationState
} = svs.racing.navigation;
const {
  Image
} = svs.content.image_v2;
const {
  location: {
    buildCouponLocation
  },
  useNavigationActions
} = svs.racing.navigation;
const {
  browser
} = svs.components.Storage;
const RenderStatisticsPopOver = _ref => {
  let {
    children,
    hasPopover
  } = _ref;
  if (!hasPopover) {
    return children;
  }
  return React.createElement(TippyReact, {
    animation: "scale-extreme",
    className: "racing-dialog",
    content: React.createElement("div", {
      className: "statistics-popover"
    }, "Nu kan du klicka p\xE5 h\xE4starna f\xF6r", React.createElement("br", null), "mer information.", React.createElement("br", null)),
    delay: [500, null],
    hideOnClick: true,
    inertia: true,
    onShown: () => {
      browser.set('statisticsDisplayed', 'Racing', true, svs.components.Storage.constants.EXPIRES_1YEAR);
    },
    placement: "top-start",
    showOnCreate: true,
    theme: "light-border",
    trigger: "click",
    zIndex: 1060
  }, children);
};
const InnerParticipantInfo = forwardRef((_ref2, ref) => {
  let {
    participant,
    canceled,
    silksFormattedDate
  } = _ref2;
  const imageOptions = participant.silks && silksFormattedDate && getImageOptions(participant.silks, silksFormattedDate, ImageTypes.CouponSilk);
  return React.createElement("div", {
    className: "center",
    ref: ref
  }, participant.silks && silksFormattedDate && React.createElement("span", {
    className: "meeting-description-additional ".concat(canceled ? 'non-starter' : '')
  }, React.createElement(Image, {
    image: imageOptions
  })), React.createElement("span", {
    className: "meeting-description ".concat(canceled ? 'non-starter strike-through' : '')
  }, "".concat(participant.participantNumber, ". ").concat(participant.horseName), React.createElement("br", null), React.createElement("span", null, "".concat(participant.driverName))));
});
const ParticipantInfo = _ref3 => {
  let {
    participant,
    canceled,
    silksFormattedDate,
    index
  } = _ref3;
  const navState = useNavigationState();
  const {
    toParticipant
  } = useNavigationActions();
  const shouldRenderPopover = index === 0 && !browser.get('statisticsDisplayed', 'Racing');
  if (svs.core.detect.formfactor.mobile()) {
    const streamPlayer = document.querySelector('.stream-player');
    const streamPlayerTop = streamPlayer ? streamPlayer.offsetTop : 0;
    return React.createElement(RevealLink, {
      animationclass: "reveal-animation-racing-statistics",
      className: "link-participant",
      customOffsetHeight: streamPlayerTop,
      disableAutoScroll: true,
      disableNavigation: true,
      key: "".concat(participant.participantId),
      postAnimationCb: () => {
        toParticipant(participant);
      },
      preAnimationCb: () => {
        document.querySelector('.reveal-animation-racing-statistics').style.setProperty('margin-top', "".concat(streamPlayerTop, "px"));
      },
      to: buildCouponLocation(_objectSpread(_objectSpread({}, navState), {}, {
        participantName: participant.horseNameUrl,
        participantId: participant.participantId,
        statisticsMenuItem: undefined
      }))
    }, React.createElement(RenderStatisticsPopOver, {
      hasPopover: shouldRenderPopover
    }, React.createElement(InnerParticipantInfo, {
      canceled: canceled,
      participant: participant,
      silksFormattedDate: silksFormattedDate
    })));
  } else if (svs.core.detect.formfactor.desktop()) {
    return React.createElement(Link, {
      className: "link-participant",
      key: "".concat(participant.participantId),
      to: buildCouponLocation(_objectSpread(_objectSpread({}, navState), {}, {
        participantName: participant.horseNameUrl,
        participantId: participant.participantId,
        statisticsMenuItem: undefined
      }))
    }, React.createElement(RenderStatisticsPopOver, {
      hasPopover: shouldRenderPopover
    }, React.createElement(InnerParticipantInfo, {
      canceled: canceled,
      participant: participant,
      silksFormattedDate: silksFormattedDate
    })));
  }
  return React.createElement(InnerParticipantInfo, {
    canceled: canceled,
    participant: participant,
    silksFormattedDate: silksFormattedDate
  });
};
svs.racing_game.components.play.ParticipantInfo = ParticipantInfo;

 })(window);